import { cn } from "@newxsystems/shared";
import { AbyssCommonContent } from "../../../../modules/content/components/AbyssCommonContent/AbyssCommonContent";
import { AbyssMedia } from "../../../../modules/content/components/AbyssMedia/AbyssMedia";
import { AbyssSection } from "../../../../modules/content/components/AbyssSection/AbyssSection";
import { VideoPlayer } from "../../../../modules/content/components/VideoPlayer/VideoPlayer";
import type { ITextMediaBlockProps } from "./TextMediaBlock.props";

export const TextMediaBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  direction,
  eyebrow,
  heading,
  image,
  parentClass,
  spacing,
  video,
}: ITextMediaBlockProps) => {
  const videoDestination =
    video?.source === "direct"
      ? video.directVideo
      : video?.source === "youtube"
        ? video.youtubeVideo
        : video?.vimeoVideo;
  const hasCopy = Boolean(eyebrow || heading || description || buttons?.length);
  if (!image && !videoDestination) return null;
  const media = (
    <div className="flex min-w-0 flex-col gap-5">
      {image ? (
        <AbyssMedia
          aspectRatio={image.aspectRatio || "16:9"}
          className="abyss-instrument-frame"
          media={image.image}
          sizes="(min-width: 768px) 50vw, 100vw"
        />
      ) : null}
      {video && videoDestination ? (
        <VideoPlayer
          banner={video.banner}
          directVideo={video.directVideo}
          source={video.source}
          vimeoVideo={video.vimeoVideo}
          youtubeVideo={video.youtubeVideo}
        />
      ) : null}
    </div>
  );
  return (
    <AbyssSection className={parentClass} id={anchorId} spacing={spacing}>
      {hasCopy ? (
        <div className="grid items-center gap-8 border-t border-iron pt-8 md:grid-cols-2 md:gap-12 lg:gap-16">
          <div
            className={cn("order-1 flex min-w-0 items-center", direction === "ltr" && "md:order-2")}
          >
            <AbyssCommonContent
              alignment={alignment}
              buttons={buttons}
              description={description}
              eyebrow={eyebrow}
              heading={heading}
            />
          </div>
          <div className={cn("order-2 min-w-0", direction === "ltr" && "md:order-1")}>{media}</div>
        </div>
      ) : (
        media
      )}
    </AbyssSection>
  );
};

TextMediaBlock.displayName = "Block::TextMediaBlock";
